import Phaser from 'phaser';
import { AppSettings } from './app/managers/AppSettings';
import { phaserConfig } from './phaser.config';
import GameScene from './scenes/GameScene';
import { LoadFont } from './utils/LoadFont';

LoadFont(AppSettings.fontFamilies.MontserratMedium, "./fonts/Montserrat-Medium.ttf", () => {
  LoadFont(AppSettings.fontFamilies.MontserratBold, "./fonts/Montserrat-Bold.ttf", () => {
    LoadFont(AppSettings.fontFamilies.MontserratBlack, "./fonts/Montserrat-Black.ttf", () => {
      const BelGame = new Phaser.Game(
        Object.assign(phaserConfig, {
          scene: [
            GameScene,
          ],
        })
      )
      window.BelGame = BelGame;;
    });
  });
});